import { createSvgComponent } from "../../icon/createSvgComponent";
import Playlist from "@core/__generated__/icon/figma/playlist.svg";
export default createSvgComponent(Playlist);